// src/pages/PrivacyPolicy.js
import React from "react";

const sections = [
  {
    title: "1. Information We Collect",
    content: [
      {
        heading: "Personal Information",
        text: "Name, age, gender, date of birth, email address, phone number, mailing address, login credentials.",
      },
      {
        heading: "Health & Fitness Data (Voluntary)",
        text: "Height, weight, BMI, fitness goals, diet preferences, exercise activity records, progress tracking.",
      },
      {
        heading: "Payment Information",
        text: "Payment method (credit/debit card, UPI, net banking, wallets), billing address, transaction history. (Note: We do not store complete card or banking details.)",
      },
      {
        heading: "Device & Technical Information",
        text: "IP address, device type, operating system, app usage data, cookies, analytics identifiers.",
      },
      {
        heading: "Communication Data",
        text: "Customer support queries, feedback, surveys, marketing preferences.",
      },
    ],
  },
  {
    title: "2. How We Use Your Information",
    content: [
      {
        text: "Provide and improve our Services, process payments and manage subscriptions, personalize fitness recommendations and diet plans, allow live streaming and class participation, send service updates, detect fraud, conduct analytics and research.",
      },
    ],
  },
  {
    title: "3. How We Share Your Information",
    content: [
      {
        text: "We do not sell your personal data. We share information only with payment processors, service providers, for legal requirements, or business transfers (merger/acquisition).",
      },
    ],
  },
  {
    title: "4. Data Retention",
    content: [
      {
        text: "We retain personal data only as long as necessary. Fitness and health data can be deleted via account settings or by contacting us.",
      },
    ],
  },
  {
    title: "5. Data Security",
    content: [
      {
        text: "We use SSL/TLS encryption, secure payment gateways, and limited access to personal data by authorized employees only.",
      },
    ],
  },
  {
    title: "6. International Data Transfers",
    content: [
      {
        text: "Your data may be processed outside India, with compliance to GDPR (EU) and CCPA (USA).",
      },
    ],
  },
  {
    title: "7. Your Rights",
    content: [
      {
        text: "Access & Portability, Correction, Deletion, Withdrawal of Consent, GDPR Rights (EU), CCPA Rights (California). To exercise these rights, email us at hello@getrevibe.app",
      },
    ],
  },
  {
    title: "8. Children’s Privacy",
    content: [
      {
        text: "Revibe health and happiness application is not intended for children under 16 years. We do not knowingly collect data from minors.",
      },
    ],
  },
  {
    title: "9. Cookies & Tracking Technologies",
    content: [
      {
        text: "We use cookies, pixels, and analytics tools (Google Analytics, Firebase, etc.) to enhance user experience.",
      },
    ],
  },
  {
    title: "10. Third-Party Links & Content",
    content: [
      {
        text: "Our App may include links to third-party websites or videos. We are not responsible for their privacy practices.",
      },
    ],
  },
  {
    title: "11. Changes to This Policy",
    content: [
      {
        text: "We may update this Privacy Policy. Continued use of our Services after changes means acceptance of the updated policy.",
      },
    ],
  },
  {
    title: "12. Contact Us",
    content: [
      {
        text: `Revibe Health and Happiness
2206, 22nd Floor, Solus, Hiranandani Estate, Patlipada, Near Hiranandani School, Thane (West), Maharashtra – 400607
Email: hello@getrevibe.app
Phone: +91 99677 22756`,
      },
    ],
  },
];

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-12 xl:px-16 py-12">
      <h1 className="text-4xl font-bold mb-8 text-gray-900 text-center">
        Privacy Policy
      </h1>

      <div className="space-y-8">
        {sections.map((section, index) => (
          <div key={index}>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>
            <ul className="list-disc list-inside space-y-3 text-gray-600">
              {section.content.map((item, i) => (
                <li key={i}>
                  {item.heading && (
                    <span className="font-medium text-gray-800">
                      {item.heading}:{" "}
                    </span>
                  )}
                  <span className="whitespace-pre-line">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* <p className="text-center text-gray-500 mt-12 text-sm">
        © {new Date().getFullYear()} Revibe Health and Happiness. All Rights
        Reserved.
      </p> */}
    </div>
  );
};

export default PrivacyPolicy;
